import { useMemo } from 'react';
import { createIntl, createIntlCache, useIntl } from 'react-intl';

import messages_es from 'assets/i18n/es.json';
import messages_pt from 'assets/i18n/pt.json';

let intl;

export const SUPPORTED_LANG = {
  // Spanish
  es: 'es',
  // Portuguese
  pt: 'pt',
};
export const DEFAULT_LANG = SUPPORTED_LANG.es;
export const DEFAULT_MESSAGES = {
  [SUPPORTED_LANG.es]: messages_es,
  [SUPPORTED_LANG.pt]: messages_pt,
};

export const initializeIntl = (
  // is optional, by default 'es'
  locale = DEFAULT_LANG,
  // is optional, you can pass custom messages
  // TODO(RA-5904): a near future re-enable like RA-5740 + RA5806
  // messages = DEFAULT_MESSAGES[locale],
  // TODO(RA-5904): middle revert before of RA-5740
  messages = DEFAULT_MESSAGES,
) => {
  // This is optional but highly recommended
  // since it prevents memory leak
  const cache = createIntlCache();
  intl = createIntl(
    {
      locale,
      // TODO(RA-5904): a near future re-enable like RA-5740 + RA5806
      // messages: messages,
      // TODO(RA-5904): middle revert before of RA-5740
      messages: messages[locale],
      defaultLocale: DEFAULT_LANG,
    },
    cache,
  );
  return intl;
};

export const getIntl = () => {
  return intl;
};

export const formatMessage = (messageObject, params) => {
  if (!intl) {
    console.error('intl not initialized');
    return null;
  }

  return intl.formatMessage(messageObject, params);
};

export const tLang = formatMessage;

export const useFormatMessage = (messageObject, params = {}) => {
  const { formatMessage } = useIntl();
  const isEmpty = !Boolean(messageObject.id);
  return useMemo(() => (isEmpty ? '' : formatMessage(messageObject, params)), [
    isEmpty ? '' : formatMessage,
    messageObject,
    params,
  ]);
};

export const useTLang = useFormatMessage;

const intlTools = {
  SUPPORTED_LANG,
  DEFAULT_LANG,
  DEFAULT_MESSAGES,
  formatMessage,
  tLang,
  getIntl,
  initializeIntl,
  useFormatMessage,
  useTLang,
};

export default intlTools;
